import { render, staticRenderFns } from "./BillAllocation.vue?vue&type=template&id=0ea1f44b&"
import script from "./BillAllocation.vue?vue&type=script&lang=js&"
export * from "./BillAllocation.vue?vue&type=script&lang=js&"
import style0 from "./BillAllocation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports